import { createContext, useState } from "react";


const WaterSourceSectionContext = createContext({
    section:1
});

export const WaterSourceSectionProvider = ({children}) => {
    const [section, setSection] = useState(1);

    const sectionAction = (data) => {
        setSection(data)
    };
    const resetWaterSourceSectionContext = () => {
        setSection(1)
    }

    return ( 
<WaterSourceSectionContext.Provider value={{section,sectionAction,resetWaterSourceSectionContext}}>
    {children}
</WaterSourceSectionContext.Provider>
    )
}

export default WaterSourceSectionContext